import { defineComponent } from "vue";
import gPdf from "@/components/g-pdf/g-pdf.vue"
import PDFItensNotaFiscal from "../PDF/PDFItensNotaFiscal.vue";

const name = 'ItensNotasFiscais'
export default defineComponent({
  name,

  components: {
    'g-pdf': gPdf,
    PDFItensNotaFiscal
  },

  props: {},

  mounted() {
    this.GetItensNotasFiscais();

    var notaId = this.$route.params.id    
    this.NotaFiscalId = notaId
  },

  updated() { },

  data() {
    return {
      itensNotasFiscaisArray: [],
      codigoExterno: null,
      serieNotaFiscal: null,
      notaFiscalCodigoExterno: null,
      NotaFiscalId: null,      
      executarvisualizacao: 0,
      renderiza: false,
      podeBaixarPdf: false,
      abrePdf: false,
    }
  },

  methods: {
    GetItensNotasFiscais() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetItensNotasFiscais/${this.$route.params.id}`,
      })
      .then((response) => {
        this.itensNotasFiscaisArray = response.data.data;
        this.codigoExterno = response.data.data[0].codigoExterno;
        this.serieNotaFiscal = response.data.data[0].serieNotaFiscal;
        this.notaFiscalCodigoExterno = response.data.data[0].notaFiscalCodigoExterno;
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    gerarPdf() {
      setTimeout(() => {
        this.executarvisualizacao++
      }, "500");
    },

    abrirPDF() {
      this.renderiza = false

      setTimeout(() => {        
        this.renderiza = true
      }, 100);

      this.abrePdf = true
      this.podeBaixarPdf = false
    }, 

    baixarPDF() {
      this.renderiza = false

      setTimeout(() => {        
        this.renderiza = true
      }, 100);

      this.abrePdf = false
      this.podeBaixarPdf = true
    },

    voltar() {
      this.$router.back()
    },
  },
});